/**
*  料金シミュレーター
*
*  通所リハビリテーション
*
*  @since 2019.9.24
*  @use jQuery
*/




/**
*  Variables
*
*  自己負担となる利用金額
*/

const array_daycare = {
  /* 介護度に応じたサービス料 */
  kaigo:
  [
    // 介護度 1 : [ 1割, 2割, 3割 ]
    {
      normal: [ 2644, 4579, 6514 ],
      short : [ 0, 0, 0 ]
    },
    // 介護度 2 : [ 1割, 2割, 3割 ]
    {
      normal: [ 2786, 4863, 6940 ],
      short : [ 0, 0, 0 ]
    },
    // 介護度 3 : [ 1割, 2割, 3割 ]
    {
      normal: [ 2923, 5136, 7350 ],
      short : [ 0, 0, 0 ]
    },
    // 介護度 4 : [ 1割, 2割, 3割 ]
    {
      normal: [ 3088, 5466, 7845 ],
      short : [ 0, 0, 0 ]
    },
    // 介護度 5 : [ 1割, 2割, 3割 ]
    {
      normal: [ 3251, 5792, 8333 ],
      short : [ 0, 0, 0 ]
    },
    {
      normal: [ 2670, 5341, 8012 ],
      short : [ 0, 0, 0 ]
    },
    {
      normal: [ 4928, 9856, 14785 ],
      short : [ 0, 0, 0 ]
    }
  ],
  // １週の利用日数 [ 週1日, 週2日, 週3日 ]
  week: [ 4, 8, 12 ]
}

// '1週間あたりの利用回数' の OPTION 項目の配列
const weekOptionArray = [
  '選択してください',
  '週1日',
  '週2日',
  '週3日'
];

/**
*  function
*  動作
*/

// 通所リハビリテーション
$( calcBtn.rehaDaycare ).on('click', function(e){
  e.preventDefault();

  const formData = $( currentForm.rehaDaycare ).serializeArray();
  const selectVal = selectCheck( currentForm.rehaDaycare, formData );
  let daysExpense, serviceExpense;

  // すべて選択されていれば flag = true
  if( selectVal ){
    /* 計算処理開始 */
    // 1日の利用時間に応じて居住費を設定
    switch( parseInt( selectVal.days, 10 ) )
    {
      // 通常（6時間以上～8時間未満）
      case 1:
        daysExpense = array_daycare.kaigo[ selectVal.kaigo ].normal[ selectVal.futan ];
      break;
      // 短時間（1時間以上2時間未満）
      case 2:
        daysExpense = array_daycare.kaigo[ selectVal.kaigo ].short[ selectVal.futan ];
      break;
      // default
      default:
        return;
      break;
    }

    // 結果を出して表示する
    const result = parseInt( daysExpense, 10) * parseInt( selectVal.weeks, 10);
    $( resultElm.rehaDaycare ).html( numberWithComma.format( result ) );
  } // end of 計算処理開始
return;
});

// '介護度' を変更したとき '1週間あたりの利用回数' の内容を書き換える
$( currentForm.rehaDaycare + ' [name="kaigo"]' ).on('change', function(){
  const kaigoValue = this.selectedIndex;
  const weekOption = this.form.weeks;

  if ( kaigoValue === 6 ) {
    weekOption.textContent = null;
    weekOption.options[0] = new Option( weekOptionArray[0], '' );
    weekOption.options[1] = new Option( weekOptionArray[1], array_daycare.week[0] );
  } else if ( kaigoValue === 7 ) {
    weekOption.textContent = null;
    weekOption.options[0] = new Option( weekOptionArray[0], '' );
    weekOption.options[1] = new Option( weekOptionArray[2], array_daycare.week[1] );
  } else {
    weekOption.textContent = null;
    weekOption.options[0] = new Option( weekOptionArray[0], '' );
    weekOption.options[1] = new Option( weekOptionArray[1], array_daycare.week[0] );
    weekOption.options[2] = new Option( weekOptionArray[2], array_daycare.week[1] );
    weekOption.options[3] = new Option( weekOptionArray[3], array_daycare.week[2] );
  }
});
